import { CanActivateFn, Router } from '@angular/router';
import { inject } from "@angular/core";
import { AuthService } from "../auth.service";
import { AppConfigService } from "../../../services/app-config.service";
import { of, switchMap } from "rxjs";

export const SuperAdminGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const appConfigService = inject(AppConfigService);
    const router = inject(Router);
    // Check if the user is authenticated and has the 'super-admin' role
    return authService.check().pipe(
        switchMap(isAuthenticated => {
            if (isAuthenticated && appConfigService.hasRole('super-admin')) {
                return of(true);
            } else {
                // Redirect to a different page or return false
                router.navigate(['/']);
            }
        })
    );
};
